import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { HomeIcon } from '@heroicons/react/24/outline';

/**
 * 404 Not Found page component
 * 
 * @returns {JSX.Element} NotFound page component
 */
export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-agentic-white-off">
      <div className="max-w-md w-full mx-4 text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-agentic-primary-blue">404</h1>
          <h2 className="text-2xl font-semibold text-agentic-text-primary mt-4">
            Page Not Found
          </h2>
          <p className="text-agentic-text-secondary mt-2">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Link to="/dashboard">
            <Button variant="primary" className="w-full">
              <HomeIcon className="h-5 w-5 mr-2" />
              Go to Dashboard
            </Button>
          </Link>
          
          <Button 
            variant="secondary" 
            onClick={() => window.history.back()}
            className="w-full"
          >
            Go Back
          </Button>
        </div>

        <div className="mt-8 text-sm text-agentic-text-muted">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

